/* global define, window, google, setInterval, AnchorOverlay, clearInterval */

// TODO AnchorOverlay to require?

define('views/OverlaysView',[
    'jquery',
    'underscore',
    'backbone',
    'text!templates/views/Overlays.html'
], function($, _, Backbone, template) {

    'use strict';

    var View = Backbone.View.extend({

        topLevelArea: null,

        areas: [],
        anchors: [],
        shapes: [],
        currentTile: null,

        strokeColor: '#000000',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#08c',
        fillOpacity: 0.10,
        selectedFillColor: '#08c',
        hoverFillColor: '#00FF00',
        hoverFillOpacity: 0,
        selectedFillOpacity: 0.45,
        drawerOpened: false,
        searchMode: false,
        lastZoomedTile: null,

        events: {
            'click .backButton': 'onBack',
            'click .expandCollapse': 'onExpandCollapse',
            'click .areaName': 'onAreaNameClick',
            'click .closedDrawerIcon': 'closeDrawerNow',
            'click .openDrawerIcon': 'openDrawer',
            'click .area-cb': 'onAreaCheckboxClick',
            'click .selectAllButton': 'onSelectAll',
            'click .selectNoneButton': 'onSelectNone',
            'click .browseButton': 'toggleDrawer',
            'keyup .search-query': 'onSearchQuery',
            'click .btn-clear': 'onClearSearchQuery',
            'click .tileName': 'onShowTileClick',
            'click .bcHome': 'onShowRootTileClick'
        },
        initialize: function() {

            // Bind All
            _.bindAll(this);

            this.$window = $(window);
            this.$window.on('resize', this.onResize);

            this.mapPackages = this.options.gmapsearch.map_packages;

        },
        onResize: function() {

            var topBarHeight = $('#topSearchBarView').outerHeight(),
                windowHeight = this.$window.height(),
                windowWidth = this.$window.width(),
                maxHeight = windowHeight - topBarHeight - 3,
                overlaysButtonBarWidth = this.$overlaysButtonBar.width();

            this.$drawer.css('max-height', maxHeight + 'px');
            this.$drawer.css('top', topBarHeight + 'px');
            this.$overlaysTable.css('max-height', (maxHeight - 72) + 'px');

            this.$overlaysButtonBar.css('left', ((windowWidth / 2) - (overlaysButtonBarWidth / 2)) + 'px');
            this.$overlaysButtonBar.css('bottom', '30px');

            this.$areaBreadcrumb.css('top', (topBarHeight + 10) + 'px');
        },
        onAreaNameClick: function(event) {

            var id = $(event.currentTarget).attr('rel'),
                area = this.areas[id],
                tile = null;

            if (!area) {
                return;
            }

            if (area.e) {
                tile = this.tiles[area.e];
            } else if (area.parent) {
                tile = area.parent;
            }

            if (tile && this.currentTile) {
                this.showTile(tile);
            }

            this.toggleAreaSelected(area);
        },
        onClearSearchQuery: function() {

            this.$el.find('.search-query').val('');
            this.search('');

        },
        onSearchQuery: function(event) {
            this.search($(event.target).val());
        },
        search: function(searchQuery) {

            var $icons = this.$overlaysTable.find('i.expandCollapse');

            //BAD

            if (searchQuery === '') {
                $('div.areas').hide();
                $('div.tiles').hide();
                $('div.top-level').show();

                $icons.removeClass('icon-minus-sign');
                $icons.addClass('icon-plus-sign');
                $icons.fadeTo('fast', 1.0);
                this.searchMode = false;
            } else {
                $('div.tile').hide();
                $('div.areas').hide();
                var $result = this.$overlaysTable.find('div.tile:containsi(\'' + searchQuery + '\')');
                $result.show().parents().show();
                $icons.fadeTo('fast', 0.1);
                this.searchMode = true;
            }

        },
        reset: function() {
            //console.log('reset!');
        },
        render: function() {

            //console.log('render');

            this.$el.html(template);

            this.$view = this.$el.find('#overlaysView');
            this.$drawer = this.$el.find('#overlaysDrawer');
            this.$overlaysView = this.$el.find('#overlaysView');
            this.$overlaysTable = this.$el.find('#overlaysTable');
            this.$backButton = this.$el.find('.backButton');
            this.tableRowTemplate = this.$el.find('#tableRowTemplate');
            this.$overlaysButtonBar = this.$el.find('#overlaysButtonBar');
            this.$areaBreadcrumb = this.$el.find('#areaBreadcrumb');

            return this;
        },
        renderTiles: function(tiles) {

            if (!tiles) {
                return;
            }

            for (var key in tiles) {
                this.renderTile(tiles[key]);
            }
        },
        renderTile: function(tile) {

            if (!tile) {
                return;
            }

            var bounds = new google.maps.LatLngBounds();

            bounds.extend(new google.maps.LatLng(tile.lt1, tile.lg1));
            bounds.extend(new google.maps.LatLng(tile.lt2, tile.lg2));

            tile.bounds = bounds;

            this.renderAreas(tile.a);
        },
        renderAreas: function(areas) {

            if (!areas) {
                return;
            }

            var i;

            for (i = 0; i < areas.length; i++) {
                this.initArea(areas[i]);
            }

            for (i = 0; i < areas.length; i++) {
                this.renderArea(areas[i]);
            }

            for (i = 0; i < areas.length; i++) {
                this.renderAnchor(areas[i]);
            }

        },
        renderArea: function(area) {

            if (!area) {
                return;
            }

            var shape = null,
                cords = [],
                _this = this,
                i = 0,
                bounds = new google.maps.LatLngBounds();

            for (i = 0; i < area.v.length; i = i + 2) {
                cords.push(new google.maps.LatLng(area.v[i], area.v[i + 1]));

            }

            for (i = 0; i < cords.length; i++) {
                bounds.extend(cords[i]);
            }
            area.bounds = bounds;

            if (area.t === 'polygon') {

                shape = new google.maps.Polygon({
                    paths: cords,
                    strokeColor: this.strokeColor,
                    strokeOpacity: this.strokeOpacity,
                    strokeWeight: this.strokeWeight,
                    fillColor: this.fillColor,
                    fillOpacity: this.fillOpacity,
                    hoverFillColor: this.hoverFillColor,
                    hoverFillOpacity: this.hoverFillOpacity,
                    clickable: true
                });

            } else if (area.t === 'rect') {

                bounds = new google.maps.LatLngBounds();

                for (i = 0; i < cords.length; i++) {
                    bounds.extend(cords[i]);
                }

                shape = new google.maps.Rectangle({
                    bounds: bounds,
                    strokeColor: this.strokeColor,
                    strokeOpacity: this.strokeOpacity,
                    strokeWeight: this.strokeWeight,
                    fillColor: this.fillColor,
                    fillOpacity: this.fillOpacity,
                    clickable: true
                });

            } else if (area.t === 'circle') {

                shape = new google.maps.Circle({
                  strokeColor: this.strokeColor,
                  strokeOpacity: this.strokeOpacity,
                  strokeWeight: this.strokeWeight,
                  fillColor: this.fillColor,
                  fillOpacity: this.fillOpacity,
                  clickable: true,
                  center: new google.maps.LatLng(area.v[0], area.v[1]),
                  radius: area.r
                });

            }
            else {
                console.log('unsupported', area.t);
            }

            area.shape = shape;
            shape.area = area;

            this.shapes.push(shape);

            google.maps.event.addListener(shape, 'click', function() {
                _this.onAreaShapeClick(shape);
            });
            google.maps.event.addListener(shape, 'mouseover', function() {
                this.setOptions({
                    fillColor: _this.hoverFillColor,
                    fillOpacity: _this.hoverFillOpacity
                });
            });
            google.maps.event.addListener(shape, 'mouseout', function() {

                if (!area.selected) {
                    this.setOptions({
                        fillColor: _this.fillColor,
                        fillOpacity: _this.fillOpacity
                    });
                } else {
                    this.setOptions({
                        fillColor: _this.selectedFillColor,
                        fillOpacity: _this.selectedFillOpacity
                    });
                }
            });

            if (area.selected) {
                this.updateShape(area.shape);
            }

            return;
        },
        renderAnchor: function(area) {

            if (!area) {
                return;
            }

            var anchor = new AnchorOverlay(
                this,
                area,
                null,
                this.onAreaShapeClick,
                this.onAreaCheckboxClick);

            area.anchor = anchor;
            this.anchors.push(anchor);

            //this.initArea(area);
            // anchor.refresh();

            return;
        },
        show: function() {

            this.search('');
            this.$overlaysTable.show();

            // Force reset
            this.currentTile = null;
            this.oldWith = null;
            this.oldHeight = null;


            this.$el.show();
            //this.render();
            //this.map.disableDoubleClickZoom();
            //
            this.onResize();

            this.closeDrawerNow();

            if (this.areas.length === 0) {
                this.loadAreas();
            }

            if (this.lastZoomedTile) {
                this.showTile(this.lastZoomedTile);
            } else {
                this.showTopLevel();
            }
        },
        hide: function() {

            if (this.dragHandler) {
                google.maps.event.removeListener(this.dragHandler);
                this.dragHandler = null;
            }
            if (this.boundsHandler) {
                google.maps.event.removeListener(this.boundsHandler);
                this.boundsHandler = null;
            }
            this.trigger('map-strick-bounds', null);
            clearInterval(this.timer);
            this.hideAll();
            this.$el.hide();
        },
        hideAnchors: function() {

            for (var i = 0; i < this.anchors.length; i++) {
                this.anchors[i].onRemove();
            }

        },
        toggleDrawer: function() {
            if (this.$overlaysTable.is(':visible')) {
                this.closeDrawerNow();
            } else {
                this.openDrawer();
            }
        },
        closeDrawerNow: function() {
            this.$drawer.width(22);
            this.$drawer.find('.openedDrawer').hide();
            this.$drawer.find('.closedDrawer').show();
            this.$drawer.fadeTo('fast', 0.75);
            this.$drawer.css('right', '0px');
            //this.$overlaysButtonBar.show();
        },
        closeDrawer: function() {

            this.trigger('drawer-closed');

            var _this = this;

            _this.timer = setInterval(function() {

                _this.closeDrawerNow();
                clearInterval(_this.timer);

            }, 3000);

        },
        openDrawer: function() {

            this.trigger('drawer-opened');

            clearInterval(this.timer);

            var drawerWidth = 300,
                //windowWidth = $(window).width(),
                windowHeight = this.$window.height(),
                topBarHeight = $('#topSearchBarView').outerHeight(),
                maxHeight = windowHeight - topBarHeight - 3;

            this.$drawer.css('max-height', maxHeight + 'px');
            this.$drawer.width(drawerWidth);
            this.$drawer.find('.openedDrawer').show();
            this.$drawer.find('.closedDrawer').hide();
            this.$drawer.fadeTo('fast', 1);
            this.$drawer.css('right', '0');

            this.$drawer.css('top', topBarHeight + 'px');
            this.$overlaysTable.css('max-height', (maxHeight - 72) + 'px');

            //this.$overlaysButtonBar.hide();

        },
        setChildren: function(area, parentTile) {

            if (!area) {
                return;
            }

            if (!area.children) {
                area.children = [];
            }

            area.parent = parentTile;

            if (area.e) {

                var tile = this.tiles[area.e],
                    child = null;

                tile.parent = parentTile;

                for (var i = 0; i < tile.a.length; i++) {
                    child = tile.a[i];
                    area.children.push(child);
                    this.setChildren(child, tile);
                }

            }

        },
        loadMapPackages: function(response) {

            if (!response) {
                return;
            }

            this.onLoadAreas(response);
        },
        loadAreas: function() {

            if (this.topLevelArea) {
                return;
            }

            var pkg = null;

            for (var i = 0; i < this.mapPackages.length; i++) {

                pkg = this.mapPackages[i];

                $.getJSON(
                    pkg.manager_url +
                    '?json=1&t=' + Math.random() + '&pkg=' + pkg.name,
                    this.loadMapPackages);

            }

        },
        initArea: function(area) {

            if (!this.options.gmapsearch.overlaySelections || this.options.gmapsearch.overlaySelections.length === 0) {
                return;
            }

            var overlaySelections = this.options.gmapsearch.overlaySelections,
                fireChange = false;


            for (var i = 0; i < overlaySelections.length; i++) {
                var selectedCode = overlaySelections[i];
                if (selectedCode === area.c) {
                    //this.selectArea(area, true);
                    area.selected = true;
                    fireChange = true;
                }
            }

            if(fireChange){
                this.trigger('selection-changed', this);
            }
        },
        onLoadAreas: function(response) {

            if (!response) {
                return;
            }

            var clustors = {},
                tiles = {},
                areas = {},
                clustor = null,
                tile = null,
                area = null,
                c = 0,
                t = 0,
                a = 0;

            // Crazy Loop
            for (c = 0; c < response.c.length; c++) {
                clustor = response.c[c];
                clustors[clustor.n] = clustor;
                for (t = 0; t < clustor.t.length; t++) {
                    tile = clustor.t[t];
                    tiles[tile.i] = tile;
                    for (a = 0; a < tile.a.length; a++) {
                        area = tile.a[a];
                        areas[area.i] = area;
                    }
                }
            }

            this.clustors = clustors;
            this.tiles = tiles;
            this.areas = areas;
            this.rootTile = tiles[response.e];

            for (a = 0; a < this.rootTile.a.length; a++) {
                area = this.rootTile.a[a];
                this.setChildren(area, this.rootTile);
                area.tile = this.rootTile;
            }

            this.renderTiles(this.tiles);
            this.addTileRow(this.rootTile, 0, this.$overlaysTable);

            if (this.options.gmapsearch.overlayTilePath &&
                this.options.gmapsearch.overlayTilePath.length > 0) {
                this.showTile(tiles[
                    this.options.gmapsearch.overlayTilePath[this.options.gmapsearch.overlayTilePath.length - 1]]);
            } else {
                this.showTopLevel();
            }


            /*

n = package name
e = entryMapId
c = clustor Array

n = package name
t = tileArray

r = row
c = col
i = id
n = package name
f = getFontSizeAdjustment (optional)
s = selected image  (optional)
d = deselected image  (optional)
lt1 = sw
lg1 = sw
lt2 = ne
lg2 = ne
a =  areasArray

i = id
n = package name
l = label
s = selectable
t = type
e = getExploreTargetId
c = code
clt1 = getCalloutAnchor
clg1 = getCalloutAnchor
clt2 = getCalloutAnchor
clg2 = getCalloutAnchor
v = vertices array

*/
        },
        addTileRow: function(tile, level, $parent) {
            for (var i = 0; i < tile.a.length; i++) {
                this.addAreaRow(tile.a[i], tile, level, $parent);
            }
        },
        addAreaRow: function(area, tile, level, $parent) {

            var model = {};
            model.tile = tile;
            model.area = area;
            model.level = level;

            var template = $.trim(this.tableRowTemplate.html()),
                html = _.template(template, model),
                $container = $($.trim(html)),
                $row = $container.find('.row'),
                $i = $row.find('i.expandCollapse');

            $parent.append($container);

            if (level === 0) {
                $container.addClass('top-level');
                $i.addClass('icon-white')
                    .addClass('icon-plus-sign')
                    .removeClass('icon-minus-sign');
            }

            $container.find('div.areas').hide();
            $container.data('area', area);

            if (area.e) {
                this.addTileRow(this.tiles[area.e], level + 1, $container.find('.areas'));
            } else {
                $i.remove();
            }

        },
        onExpandCollapse: function(event) {

            if (this.searchMode === true) {
                return;
            }

            var $icon = $(event.currentTarget),
                rel = $icon.attr('rel'),
                $area = this.$overlaysTable.find('div.areas[rel=\'' + rel + '\']');



            if ($icon.hasClass('icon-minus-sign')) {
                $area.hide();
            } else {
                $area.show().parents().show();
                $area.find('div.tile').show();
                //this.$overlaysTable.find("div.areas[rel='" + rel + "']").hide().children('.tile').show();
                //this.$overlaysTable.find("div.areas[rel='" + rel + "']").show();
            }

            $icon.toggleClass('icon-minus-sign');
            $icon.toggleClass('icon-plus-sign');

            //icon-minus-sign
        },
        hideAll: function() {

            var i = 0,
                shape = null,
                anchor = null;

            for (i = 0; i < this.shapes.length; i++) {
                shape = this.shapes[i];
                shape.setMap(null);
                /*
if(!shape.area.selected){
shape.setMap(null);
}*/
            }

            for (i = 0; i < this.anchors.length; i++) {
                anchor = this.anchors[i];
                anchor.setMap(null);
            }

        },
        showTopLevel: function() {

            if (this.rootTile) {
                this.showTile(this.rootTile);
            }

        },
        showTile: function(tile) {

            if (tile === null) {
                return;
            }

            this.currentTile = tile;
            this.hideAll();

            if (this.currentTile && this.currentTile.parent) {
                this.$backButton.show();
            } else {
                this.$backButton.hide();
            }

            var area = null;

            if (tile && tile.a) {

                for (var i = 0; i < tile.a.length; i++) {
                    area = tile.a[i];
                    this.showArea(area);
                }

                this.focusOnTile(tile);

                //this.render();
            }

            this.updateBreadcrumbs();

            this.trigger('selected-changed', this);
        },
        showArea: function(area) {

            if (area === null) {
                return;
            }

            this.trigger('map-show', area.shape);
            this.trigger('map-show', area.anchor);

        },
        onBack: function() {

            if (this.currentTile && this.currentTile.parent) {
                this.showTile(this.currentTile.parent);
            }

        },
        selectArea: function(area, value) {

            if (!area) {
                return;
            }

            // Toggle
            if (!value) {
                value = !area.selected;
            }

            // Select Children
            if (area.e) {
                var tile = this.tiles[area.e];
                for (var a = 0; a < tile.a.length; a++) {
                    this.selectArea(tile.a[a], value);
                }
            }

            // Set Selected
            area.selected = value;

            this.updateShape(area.shape);

            /*
			if(area.anchor){
				area.anchor.refresh();
			}*/
            /*

			if(area.shape){
				console.log('here!', area);
				this.updateShape(area.shape);	
			}
*/



            return;
        },
        toggleAreaSelected: function(area, override, overrideRecursive) {

            if (!area) {
                return;
            }

            var selected = !area.selected,
                recursive = true;

            if (override !== undefined) {
                selected = override;
            }
            if (overrideRecursive !== undefined) {
                recursive = overrideRecursive;
            }

            area.selected = selected;

            if (recursive && area.children && area.children.length > 0) {
                for (var i = 0; i < area.children.length; i++) {
                    this.toggleAreaSelected(area.children[i], selected);
                }
            }

            if (area.anchor) {
                area.anchor.refresh();
            }

            this.updateShape(area.shape);
            this.updateCheckbox(area.shape);

            this.trigger('selection-changed', this);

        },
        onAreaShapeClick: function(shape) {

            if (!shape) {
                return;
            }

            var area = shape.area;

            if (!area.e) {
                this.toggleAreaSelected(shape.area);
            } else {
                var tile = this.tiles[area.e];
                this.showTile(tile);
            }


        },
        onAreaCheckboxClick: function(event) {

            var $checkbox = $(event.currentTarget),
                id = $checkbox.attr('rel'),
                area = this.areas[id];

            this.toggleAreaSelected(area);

        },
        onSelectAll: function() {

            var tile = this.currentTile,
                area = null;

            for (var i = 0; i < tile.a.length; i++) {
                area = tile.a[i];
                this.toggleAreaSelected(area, true, true);
            }

        },
        onSelectNone: function() {

            var tile = this.currentTile,
                area = null;

            for (var i = 0; i < tile.a.length; i++) {
                area = tile.a[i];
                this.toggleAreaSelected(area, false, true);
                area.anchor.refreshAnchor();
            }

        },
        updateCheckbox: function(shape) {

            if (!shape) {
                return;
            }

            var area = shape.area,
                $checkbox = this.$overlaysTable.find('.area-cb-' + area.i);

            $checkbox.prop('checked', area.selected);

        },
        updateShape: function(shape) {

            if (!shape) {
                return;
            }

            if (shape.area.selected) {
                shape.setOptions({
                    fillColor: this.selectedFillColor,
                    fillOpacity: this.selectedFillOpacity
                });
            } else {
                shape.setOptions({
                    fillColor: this.fillColor,
                    fillOpacity: this.fillOpacity
                });
            }

            if(shape.area.anchor){
                shape.area.anchor.refresh();
            }

        },
        focusOnTile: function(tile) {

            if (tile === null) {
                return;
            }

            this.trigger('map-fit-bounds', tile.bounds);
            this.trigger('map-zoom-increment');

            if (!tile.strictBounds) {
                tile.strictBounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(tile.lt1, tile.lg1),
                    new google.maps.LatLng(tile.lt2, tile.lg2));
            }

            this.trigger('map-strick-bounds', tile.strictBounds);
            this.lastZoomedTile = tile;

        },
        getChildrenCount: function(area) {
            var count = 0;

            for (var i = 0; i < area.children.length; i++) {

                var child = area.children[i];
                count++;
                count = count + this.getChildrenCount(child);
            }

            return count;
        },
        getChildrenSelectedCount: function(area) {

            var selectedCount = 0;

            if (!area || !area.children || area.children.length === 0) {
                return 0;
            }

            for (var i = 0; i < area.children.length; i++) {

                var child = area.children[i];

                if (child.selected) {
                    selectedCount++;
                }

                selectedCount = selectedCount +
                    this.getChildrenSelectedCount(child);
            }

            return selectedCount;
        },

        getAnchorLabel: function(area) {

            var label = area.n,
                selectedCount = 0;

            selectedCount = this.getChildrenSelectedCount(area);


            /*for (var i = 0; i < area.children.length; i++) {
				if (area.children[i].selected) {
					selectedCount++;
				}
			}*/

            if (selectedCount > 0) {

                if (selectedCount !== area.children.length) {
                    label += ' (' + selectedCount + '/' + this.getChildrenCount(area) + ')';
                }

                area.selected = true;
            }

            if (area.children.length > 0 && selectedCount === 0) {
                area.selected = false;
            }

            this.updateShape(area.shape);

            return label;
        },
        zoomToSelectedRegions: function() {

            var bounds = new google.maps.LatLngBounds(),
                area = null;

            for (var id in this.areas) {

                area = this.areas[id];

                if (area.selected && area.bounds) {
                    bounds.union(area.bounds);
                }
            }

            this.trigger('map-fit-bounds', bounds);

        },
        createPath: function(path, tile) {

            if (tile) {

                if (tile.i) {
                    path = tile.i + '|' + path;
                }

                if (tile.parent) {
                    path = this.createPath(path, tile.parent);
                }
            }

            return path;
        },
        onShowRootTileClick: function() {
            this.showTile(this.rootTile);
        },
        onShowTileClick: function(event) {

            var id = $(event.target).attr('rel');
            this.showTile(this.tiles[id]);
        },
        updateBreadcrumbs: function() {

            var path = this.createPath('', this.currentTile),
                values = path.substring(0, path.length - 1).split('|'),
                $ul = this.$areaBreadcrumb.find('ul'),
                $crumb = null,
                tileId = null,
                tile = null;

            $ul.find('li.bcTile').remove();

            for (var i = 0; i < values.length; i++) {

                tileId = values[i];

                if (tileId.length === 0 || i === 0) {
                    continue;
                }

                tile = this.tiles[tileId];

                if (i !== values.length - 1) {
                    $crumb = $('<li class="bcTile"><a href="#" class="tileName" rel="' + tile.i +
                        '">' + tile.n + '</a></li>');
                } else {
                    $crumb = $('<li class="bcTile active"><a href="#">' + tile.n + '</a></li>');
                }

                $ul.append($crumb);
            }

        },

        getFormData: function() {

            var formData = {},
                area = null;


            // TODO find example of multiple map packages
            var pkg = this.mapPackages[0];
            //formData.overlayPackageName = this.rootTile.n;
            formData.overlayPackageName = pkg.name;

            // Set Path
            var path = this.createPath('', this.currentTile);
            if (path.endsWith('|')) {
                path = path.substring(0, path.length - 1);
            }
            formData.overlayTilePath = path;
            formData.leafCodeSelections = '';
            formData.finishSearch = true;
            formData.__free_poly_type = '';
            formData.__free_poly_spec = '';
            formData.__free_poly_points = '';

            var hasSelection = false;

            var counter = 0;

            for (var key in this.areas) {
                area = this.areas[key];

                if (area.selected) {
                    if (area.c) {
                        counter++;
                        formData.leafCodeSelections += $.trim(area.c) + '|';
                        hasSelection = true;
                    }
                }

            }

            if (hasSelection) {
                formData.leafCodeSelections = formData.leafCodeSelections.substring(0, formData.leafCodeSelections.length - 1);
                //formData.overlaySelections = formData.leafCodeSelections;
            }

            return formData;

        },
        onSearch: function(callback, forceClear) {

            // TODO make this an event based update
            this.closeDrawerNow();
            var formData = this.getFormData();
            callback(formData, forceClear);
        }



    });
    return View;
});

